import { Component } from '@theme/component';

/**
 * `<brand-logo-marquee>` — pause/play control for the brand-logo marquee
 * (WCAG 2.2.2 "Pause, Stop, Hide"). The animation itself is pure CSS; this
 * component only toggles the `is-paused` class and keeps the button's
 * accessible label and icon in sync.
 *
 * @extends {Component}
 */
class BrandLogoMarquee extends Component {
  /**
   * Toggles the marquee animation.
   */
  togglePlayback() {
    const paused = this.classList.toggle('is-paused');
    const { toggle } = this.refs;
    if (!(toggle instanceof HTMLElement)) return;

    const label = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;
    if (label) toggle.setAttribute('aria-label', label);
  }
}

if (!customElements.get('brand-logo-marquee')) {
  customElements.define('brand-logo-marquee', BrandLogoMarquee);
}
